app.service('MOP', function (log, orderConfig, console, message, modal, loading, broker, cookie, ajaxOrder, front) {

	var config;
	var loadingTimeout, initializingTimeout, initializedTimeout;
	broker.on('PAGE_CONFIG_INIT', function () {
		config = orderConfig.getData();
		if (config.pageType == 'order-payment-module' || config.pageType == 'account-payment-module' || config.pageType == 'gift-card-order-payment-module') {
			fastInit();
		}
	});
	function event(f04) {
		log.event({ id: 'komunikacja_MOP-SI', f04: f04, f03: config.orderNumber });
		UA.interaction('komunikacja_MOP-SI', f04, config.orderNumber);
	}
	function init() { }
	let isOneInit = false;
	function fastInit() {

		loadingTimeout = setTimeout(function () {
			cancelPayment('PAYMENT_ORDER_LOADING_TIMEOUT');
		}, config.webComponentLoadingTimeout);
		initializingTimeout = setTimeout(function () {
			cancelPayment('PAYMENT_ORDER_INITIALIZING_TIMEOUT');
		}, config.webComponentInitializingTimeout);
		initializedTimeout = setTimeout(function () {
			cancelPayment('PAYMENT_ORDER_INITIALIZED_TIMEOUT');
		}, config.webComponentInitializedTimeout);
		

		if(!isOneInit){
			isOneInit = true;
			window.broker.on('PAYMENT_ORDER_REJECTED', function () {
				console.log('SI: przechwycenie informacji że MOP się nie uruchomił, ma problem, oddaje SI przekierowanie użytkownika dalej po błędzie');
				cancelPayment('PAYMENT_ORDER_REJECTED');
			});

			window.broker.on('PAYMENT_ORDER_PREVIEW_ORDER', function () {
				event('PAYMENT_ORDER_PREVIEW_ORDER');
				console.log('SI: przejście na finalizację aby tylko zobaczyć podgląd');
				goToNextPage();
			});

			window.broker.on('PAYMENT_ORDER_SUCCESS', function () {
				event('PAYMENT_ORDER_SUCCESS');
				success();
			});

			window.broker.on('PAYMENT_ORDER_ERROR', function () {
				event('PAYMENT_ORDER_ERROR');
				console.log('SI: przejście na finalizację z porażką');
				goToNextPage();
			});

			window.broker.on('PAYMENT_ORDER_USER_ACTION', function () {
				event('PAYMENT_ORDER_USER_ACTION');
			});

			window.broker.on('PAYMENT_ORDER_TIMEOUT_USER_ACCEPTED', function () {
				event('PAYMENT_ORDER_TIMEOUT_USER_ACCEPTED');
				goToNextPage('/customer-current-orders.bhtml');
			});

			window.broker.on('PAYMENT_ORDER_USER_ACCOUNT', function () {
				event('PAYMENT_ORDER_USER_ACCOUNT');
				goToNextPage('/customer-current-orders.bhtml');
			});

			window.broker.on('PAYMENT_ORDER_MODULE_LOADING', function () {
				event('PAYMENT_ORDER_MODULE_LOADING');
				clearTimeout(loadingTimeout);
			});

			window.broker.on('PAYMENT_ORDER_MODULE_INITIALIZING', function () {
				event('PAYMENT_ORDER_MODULE_INITIALIZING');
				clearInterval(initializingTimeout);
			});

			window.broker.on('PAYMENT_ORDER_MODULE_INITIALIZED', function () {
				event('PAYMENT_ORDER_MODULE_INITIALIZED');
				$('#order-payment-module, #account-payment-module').addClass('mop-initialized');
				clearInterval(initializedTimeout);
			});
		}

	}
	function goToNextPage(href) {
		if (!href) {
			if (config.pageType == 'account-payment-module') {
				href = '/konto-platosc-powrot.bhtml?paymentId=' + config.paymentModuleDataId;
			} else if (config.pageType == 'gift-card-order-payment-module') {
				href = '/karta-podarunkowa-potwierdzenie.bhtml';
			} else {
				href = '/order-finalize.bhtml';
			}
		}
		event('PAYMENT_ORDER_REDIRECT');
		if (cookie.get('atrUser')) {					// na potrzeby testów chwilę przetrzymuję przekierowanie aby można było sprawdzić czy wrócił na mop
			setTimeout(function () {
				redirect(href);
			}, 2000);
		} else {
			redirect(href);
		}
	}
	function redirect(href){
		if(href == '/order-finalize.bhtml' && testAB.getVar('ajax-order') === 'B' && front.getParam('ajaxOrder')){
			ajaxOrder.get({
				href: href,
				scroll: '.page'
			});
		} else {
			loading.redirect(href);
		}
	}
	var cancelProccesing = false;
	function cancelPayment(cancelType) {
		window.broker.trigger('CANCEL_ORDER_PAYMENT_PROCESSING');
		$('payment-module').remove();
		if (cancelProccesing) {
			return;
		}
		cancelProccesing = true;
		function errorMessage() {
			message.get('payment-module-webcomponent-error').then(function (result) {
				loading.stop();
				modal.generate({
					id: 'payment-module-webcomponent-error',
					content: result,
					close: false,
					buttons: [
						{
							text: 'Spróbuj ponownie',
							cssClass: 'btn-second',
							click: function () {
								modal.close();
							}
						}
					],
					callbackClose: function () {
						goToNextPage();
					}
				});
			});
		}
		clearTimeout(loadingTimeout);
		clearInterval(initializingTimeout);
		clearInterval(initializedTimeout);
		event(cancelType);
		if (config.isPaymentCancellable) {
			event('PAYMENT_ORDER_SEND_CANCEL');
			loading.start();
			$.ajax({
				url: '/orderpayment/paymentmodule/transactions/delete.ltr',
				method: 'POST',
				dataType: "json",
				data: {
					paymentId: config.paymentModuleDataId
				},
				success: function (json) {
					console.log('udane przełączenie płatności');
					if (cancelType === 'PAYMENT_ORDER_REJECTED') {
						event('PAYMENT_ORDER_SEND_CANCEL_ERROR');
						errorMessage();
					} else if (json.error) {
						event('PAYMENT_ORDER_SEND_CANCEL_ERROR');
						errorMessage();
					} else {
						goToNextPage();
					}
				},
				error: function () {
					console.log('błąd komunikacji płatności');
					goToNextPage();
				}
			});
		} else {
			errorMessage();
		}
	}
	function success() {
		console.log('SI: sprawdzenie stanu');
		var timeout = config.mopTimeout;
		var revisions = config.mopRevisions;
		function check() {
			$.ajax({
				url: '/orderpayment/paymentmodule/transactions/status.ltr',
				data: {
					paymentId: config.paymentModuleDataId
				},
				success: function (result) {
					if (result.status === 'COMPLETED') {
						console.log('SI: przejście na finalizację z sukcesem');
						goToNextPage();
					} else if (result.status === 'FAILED') {
						console.log('SI: przejście na finalizację z porażką');
						goToNextPage();
					} else {
						revisions--;
						if (revisions > 0) {
							setTimeout(function () {
								check();
							}, timeout);
						} else {
							console.log('SI: przejście na finalizację po limicie prób');
							goToNextPage();
						}
					}
				},
				error: function () {
					console.log('SI: przejście na finalizację po błędzie komunikacji');
					goToNextPage();
				}
			});
		}
		check();
	}
	return {
		init
	};
});
